import { LinkDetails, LinkDto } from '@flyfreely-portal-ui/flyfreely';
import { Observable } from 'rxjs';

export interface ILinksService {
    loadLinks(sectionId: number);

    // get links$(): Observable<LinkDto[]>;
    createLink(sectionId: number, details: LinkDetails): Observable<LinkDto>;
    updateLink(
        sectionId: number,
        linkId: number,
        details: LinkDetails
    ): Observable<LinkDto>;

    deleteLink(sectionId: number, linkId: number): Observable<boolean>;
}

export enum LinkAction {
    noticeAirworthiness = 'AIRWORTHINESS',
    generalTask = 'GENERAL_TASK',
    lotam = 'LOTAM'
    // sample for mission
    // mission = 'mission',
}
